import { ArrowDownRight, ArrowUpRight } from "lucide-react";
import DashboardCard from "./DashboardCard";
import { KPIItem } from "../../../../types/api/dashboard";



const KPIStatCard = ({ item }: { item: KPIItem }) => {
  return (
    <DashboardCard className="p-5 hover:-translate-y-0.5 transition-all duration-150" onClick={item.onClick}>
      <div className="flex items-center justify-between mb-3">
        <span className="text-slate-500 text-xs font-medium uppercase tracking-wide">
          {item.title}
        </span>

        <div
          className={`w-8 h-8 rounded-lg flex items-center justify-center ${item.iconBg}`}
        >
          <div className={item.iconColor}>{item.icon}</div>
        </div>
      </div>

      <div className="text-2xl font-bold text-slate-800">
        {item.value}
      </div>

      <div className="flex items-center gap-1 mt-1">
        {item.type === "positive" && (
          <ArrowUpRight
            size={14}
            className="text-emerald-500"
          />
        )}

        {item.type === "negative" && (
          <ArrowDownRight
            size={14}
            className="text-red-500"
          />
        )}

        <span
          className={`text-xs font-medium ${
            item.type === "positive"
              ? "text-emerald-600"
              : item.type === "negative"
              ? "text-red-500"
              : "text-slate-500"
          }`}
        >
          {item.change}
        </span>
      </div>
    </DashboardCard>
  );
};
export default KPIStatCard